export default "__VITE_ASSET__B1lT_ME5__"